import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { with: String }

  connect() {
    this.element.dataset['action'] = 'click->disable#handleClick';

    // Default message if not set
    if (!this.hasWithValue) {
      this.withValue = "Processing...";
    }
  }

  handleClick(event) {
    event.preventDefault(); // Prevent the default link action

    // Show confirmation dialog
    if (confirm(this.element.dataset.turboConfirm)) {
      // If confirmed, proceed with disabling
      this.disableLink();

      // Manually navigate to the link's href after processing
      window.location.href = this.element.href;
    }
  }

  disableLink() {
    this.element.classList.add('disabled');  // Add Bootstrap's disabled class
    this.element.setAttribute('aria-disabled', 'true'); // Accessibility improvement

    // Replace link text with processing message
    this.element.innerHTML = `
      ${this.withValue}
      <span class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
    `;
  }
}
